module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "py-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontaktfelder")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Neben festen Kontaktfeldern können beliebig viele eigene Kontaktfelder hinzugefügt werden.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "py-2 px-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n                Pflichtfelder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Pflichtfelder können nicht entfernt werden, da sie für die Anwendung zwingend notwendig sind.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.pflichtFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0), _vm._v(" "), _c('v-card-title', [_vm._v("\n                Standardfelder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Standardfelder sind nicht verpflichtend bieten aber einige Vorteile, da sie z.B. in Widgets verwendet werden.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.standardFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      },
      on: {
        "click": function($event) {
          return _vm.addStandardfeld(item)
        }
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0), _vm._v(" "), _c('v-card-title', [_vm._v("\n                Gelöschte Felder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Eigene Felder die du gelöscht hast. Du kannst sie erneut hinzufügen.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.deletedFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "height": "650px",
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Variable Kontaktfelder")]), _vm._v(" "), _c('th', [_vm._v("Art")]), _vm._v(" "), _c('th', [_vm._v("Bearbeitbar")]), _vm._v(" "), _c('th', [_vm._v("Feldbreite")]), _vm._v(" show: false,\n                    "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20px"
    }
  }, [_vm._v("Im Profil-Dialog zeigen")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "group": "myGroup",
      "tag": "tbody"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.kontaktfelder),
      callback: function($$v) {
        _vm.kontaktfelder = $$v
      },
      expression: "kontaktfelder"
    }
  }, _vm._l((_vm.kontaktfelder), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "170px"
      }
    }, [(!item.default) ? _c('v-select', {
      attrs: {
        "hide-details": "",
        "dense": "",
        "outlined": "",
        "items": _vm.types
      },
      on: {
        "change": function($event) {
          return _vm.updateKontaktfelder()
        }
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.type === 'Select' && !item.default) ? _c('td', [_c('v-combobox', {
      attrs: {
        "hide-details": "auto",
        "hint": "Optionen Eingeben und mit Enter bestätigen",
        "multiple": "",
        "small-chips": "",
        "deletable-chips": "",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: (item.options),
        callback: function($$v) {
          _vm.$set(item, "options", $$v)
        },
        expression: "item.options"
      }
    })], 1) : _c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "width": "50px"
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "dense": "",
        "flat": "",
        "items": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      },
      on: {
        "change": function($event) {
          return _vm.updateKontaktfelder()
        }
      },
      model: {
        value: (item.breite),
        callback: function($$v) {
          _vm.$set(item, "breite", $$v)
        },
        expression: "item.breite"
      }
    })], 1), _vm._v(" "), (item.show) ? _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (item.show = !item.show);
          _vm.updateKontaktfelder()
        }
      }
    }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (item.show = !item.show);
          _vm.updateKontaktfelder()
        }
      }
    }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [(!item.required) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropKontaktfeld(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)])
  }), 0)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Kontaktfeld hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.addKontaktfeld
    },
    model: {
      value: (_vm.kontaktfeld),
      callback: function($$v) {
        _vm.kontaktfeld = $$v
      },
      expression: "kontaktfeld"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Status")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Definiert die Auswahlmöglichkeiten des Feld \"Status\". Kontakte die Mitglied sind können Informationen von anderen Mitglieder ansehen.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "400px",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("gilt als Mitglied")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alleStatus), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), ((item.mitglied === true)) ? _c('td', {
      staticClass: "text-center"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleMitglied(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleMitglied(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropStatus(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Status hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.addStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Finanzfelder")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "SEPA-Lastschriftmandat abfragen",
      "hide-details": "",
      "density": "compact"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.finanzFelder.showSepaMandat),
      callback: function($$v) {
        _vm.$set(_vm.finanzFelder, "showSepaMandat", $$v)
      },
      expression: "finanzFelder.showSepaMandat"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "IBAN, BIC etc. abfragen",
      "hide-details": "",
      "density": "compact"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.finanzFelder.showBankdaten),
      callback: function($$v) {
        _vm.$set(_vm.finanzFelder, "showBankdaten", $$v)
      },
      expression: "finanzFelder.showBankdaten"
    }
  })], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "200px",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Beitragsfelder")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.finanzFelder.beitrage), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropBeitrag(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Status hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBeitrag()
      }
    },
    model: {
      value: (_vm.finanzBeitrag),
      callback: function($$v) {
        _vm.finanzBeitrag = $$v
      },
      expression: "finanzBeitrag"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f02b78a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Kontakte.vue
// module id = 741
// module chunks = 15